import { AppIcon, InfoModal } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Alert, Box, Button, CircularProgress, Typography, SxProps, Theme } from '@mui/material';

const STRINGS = appStrings.modules.survey.output.blueprintSection.lockInModal;

type LockInConfirmationModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  error: string | null;
}>;

export function LockInConfirmationModal({
  open,
  onClose,
  onConfirm,
  isLoading,
  error,
}: LockInConfirmationModalProps) {
  return (
    <InfoModal
      open={open}
      onClose={onClose}
      width="sm"
      featuredIcon={{
        iconName: 'Map01',
        size: 'lg',
        shape: 'round',
        color: 'Brand/600',
        backgroundColor: 'Brand/100',
        border: false,
      }}
      headerContent={<Typography variant="text-lg-semibold">{STRINGS.title}</Typography>}
      bodyContent={
        <Box sx={bodySx}>
          <Typography variant="text-sm-regular" sx={descriptionSx}>
            {STRINGS.description}
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <Box sx={actionsSx}>
            <Button
              id="lock-in-cancel-btn"
              hierarchy="Secondary gray"
              size="lg"
              onClick={onClose}
              disabled={isLoading}
            >
              {STRINGS.cancel}
            </Button>
            <Button
              id="lock-in-confirm-btn"
              hierarchy="Primary"
              size="lg"
              onClick={onConfirm}
              disabled={isLoading}
              icon="Leading"
              startIcon={
                isLoading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <AppIcon iconName="Lock01" diameter="20px" color="Colors/Base/White" />
                )
              }
            >
              {STRINGS.confirm}
            </Button>
          </Box>
        </Box>
      }
    />
  );
}

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
});

const descriptionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: backrs.spacing['spacing-lg'],
});
